import React from "react";
import { Link } from "react-router-dom";
import man from "../images/Icons/man.png";
import home from "../images/Icons/home.png";
import news from "../images/Icons/news.png";
import enquiry from "../images/Icons/enquiry.png";
import bookmark from "../images/Icons/bookmark.png";
import quotation from "../images/Icons/rfq.png";
import kyc from "../images/Icons/kyc.png";
import order from "../images/Icons/product-icon.png";
import wallet from "../images/Icons/wallet.png";
import address from "../images/Icons/location.png";
import supplier from "../images/Icons/seller.png";
import transporter from "../images/Icons/transport.png";
import product from "../images/Icons/products.png";
import faq from "../images/Icons/faq.png";
import feedback from "../images/Icons/feedback.png";
import app from "../images/Icons/app.png";
import signout from "../images/Icons/logout.png";
import contact from "../images/Icons/customer.png";
import staff from "../images/Icons/testimonial.png";
import config from "../config";
import useLogout from "../View/Auth/useLogout";
import CheckAuth from "../View/Auth/CheckAuth";
import { canAccessRoute, hasWalletAccess } from "../utils/permissionUtils";

export default function SideBar() {
  const user = config.user;
  const isAuth = CheckAuth();
  const logout = useLogout();

  const handleLogout = async (e) => {
    e.preventDefault();
    await logout(true);
  };

  const handleOverlayClick = () => {
    document.body.classList.remove("mmenu-active");
  };

  const handleCloseClick = (e) => {
    e.stopPropagation();
    document.body.classList.remove("mmenu-active");
  };

  const userData = user ? user : "";


  return (
    <>
      {/* Code For sidebar*/}
      <div className="mobile-menu-overlay" onClick={handleOverlayClick}></div>
      <div className="mobile-menu-container">
        <div className="mobile-menu-wrapper" onClick={handleCloseClick}>
          <div className="mobile-menu-header">
            {user ? (
              <Link to="/profile">
                <div className="user-profile">
                  <img src={man} alt="user" />
                  <div className="name">
                    <p className="one-line-clamp">{userData.company_name}</p>
                    <small>
                      {userData.type === "transporter"
                        ? "Transporter"
                        : userData.type === "seller"
                          ? userData.type + "/Buyer"
                          : userData.type && "Buyer"}
                      {userData.is_staff ? " Staff" : ""} {userData.is_staff ? `(${userData.role ?? "N/A"})` : ""}
                    </small>
                  </div>
                </div>
              </Link>
            ) : (
              <Link to="/login">
                <div className="user-profile">
                  <img src={man} alt="user" />
                  <div className="name">
                    <p className="login_text">Login/Register</p>
                  </div>
                </div>
              </Link>
            )}
          </div>

          {/**Side bar content */}
          <div className="tab-content">
            <ul className="mobile-menu">
              <li>
                <Link to="/">
                  <img src={home} alt="" />
                  Home
                </Link>
              </li>
              <li>
                <Link to="/news-list">
                  <img src={news} alt="" />
                  News
                </Link>
              </li>
              <li>
                <Link to="/enquiry">
                  <img src={enquiry} alt="" /> Enquiry
                </Link>
              </li>
              {isAuth && (
                <li>
                  <Link to="/watchlist">
                    <img src={bookmark} alt="" /> Watch List
                  </Link>
                </li>
              )}
              {isAuth && (
                <li>
                  <Link to="/profile">
                    <img src={kyc} alt="" /> KYC
                  </Link>
                </li>
              )}
              {isAuth && canAccessRoute('quotation-list') && (
                <li>
                  <Link to="/quotation-list/received">
                    <img src={quotation} alt="" /> Quotation List
                  </Link>
                </li>
              )}
              {isAuth && canAccessRoute('order-book') && (
                <li>
                  <Link to="/order-book">
                    <img src={order} alt="" /> Order Book
                  </Link>
                </li>
              )}
              {isAuth && user && user.type === "seller" && canAccessRoute('commodity-products') && (
                <>
                  <li>
                    <Link to="/commodity-products">
                      <img src={product} alt="" /> My Products
                    </Link>
                  </li>
                </>
              )}
              {isAuth && user && user.type !== "transporter" && user.is_staff === 0 && (
                <>
                  <li>
                    <Link to="/staff-list">
                      <img src={staff} alt="" /> Staff
                    </Link>
                  </li>
                </>
              )}
              {isAuth && user && user.type === "transporter" && (
                <li>
                  <Link to="/transporter/enquiry">
                    <img src={product} alt="" />
                    My Dashboard
                  </Link>
                </li>
              )}
              {isAuth && (() => {
                const walletAccess = hasWalletAccess();
                // console.log('Wallet Access Check:', { 
                //   user: config.user, 
                //   hasWalletAccess: walletAccess 
                // });
                return walletAccess;
              })() && (
                  <li>
                    <Link to="/wallet">
                      <img src={wallet} alt="" /> Wallet
                    </Link>
                  </li>
                )}
              {(user === null || user.type === "customer") && (
                <li>
                  <Link to="/become-supplier">
                    <img src={supplier} alt="" /> Become Seller
                  </Link>
                </li>
              )}
              {(user === null || user.type === "customer") && (
                <li>
                  <Link to="/become-transporter">
                    <img src={transporter} alt="" /> Become Transporter
                  </Link>
                </li>
              )}
              {isAuth && (
                <li>
                  <Link to="/address">
                    <img src={address} alt="" /> Address
                  </Link>
                </li>
              )}
              <li>
                <Link to="/faq">
                  <img src={faq} alt="" /> FAQ
                </Link>
              </li>
              <li>
                <Link to="/contact-us">
                  <img src={contact} alt="" />
                  Contact Us
                </Link>
              </li>
              <li>
                <Link to="/about-us">
                  <img src={feedback} alt="" /> About Us
                </Link>
              </li>
              <li>
                <Link to="/">
                  <img src={app} alt="" /> Download App
                </Link>
              </li>
              {isAuth && (
                <li>
                  <Link to="/" onClick={handleLogout}>
                    <img src={signout} alt="" /> Logout
                  </Link>
                </li>
              )}
            </ul>
          </div>
        </div>
      </div>
    </>
  );
}
